import React from 'react';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

export function Card({ title, href, onClick, children }) {
  return (
    <div
      onClick={onClick}
      className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md hover:border-cyan-500 transition-all cursor-pointer group flex flex-col justify-between"
    >
      <div>
        <h4 className="font-semibold text-gray-900 group-hover:text-cyan-600 flex items-center justify-between">
          {title}
          <ArrowRightIcon className="w-4 h-4 text-gray-400 group-hover:text-cyan-600 transition-transform group-hover:translate-x-1" />
        </h4>
        {children && <div className="text-sm text-gray-600 mt-2">{children}</div>}
      </div>
    </div>
  );
}

export function Cards({ children }) {
  const childrenArray = React.Children.toArray(children).filter((child) => {
    if (typeof child === 'string') {
      return child.trim().length > 0;
    }
    return true;
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-6">
      {childrenArray}
    </div>
  );
}

Cards.Card = Card;

export default Cards;
